console.log("🤖 [Buddify Script] Shadow DOM Piercer loaded.");

document.addEventListener("DOMContentLoaded", function() {
  function openBuddifyAI() {
    console.log("🤖 [Buddify Script] Looking inside the Shadow DOM container...");
    
    // Target the exact host element you provided
    const host = document.getElementById('buddify-smart-shopping-tab-host');
    
    if (host && host.shadowRoot) {
      // Drill past the shadowRoot boundary to target the inner button elements
      const innerButton = host.shadowRoot.querySelector('button[data-tab="ai-rep"]') || 
                          host.shadowRoot.querySelector('.buddify-tab--accent') ||
                          host.shadowRoot.querySelector('.buddify-tab') ||
                          host.shadowRoot.querySelector('button');

      if (innerButton) {
        console.log("✅ [Buddify Script] Target button found inside Shadow DOM!", innerButton);
        innerButton.click();
        return;
      }
    }
    
    // Fallback: If shadowRoot isn't ready, click the host directly as a trigger pass-through
    if (host) {
      console.log("⚠️ [Buddify Script] Button not found inside shadow root yet. Attempting host element click fallback.");
      host.click();
    } else {
      console.error("❌ [Buddify Script] Error: Element #buddify-smart-shopping-tab-host missing from page.");
    }
  }

  // Listen for your #live-chat text links or menu clicks
  document.querySelectorAll('a[href="#live-chat"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();
      openBuddifyAI();
    });
  });

  // Listen for direct address bar entries ending in /#live-chat
  if (window.location.hash === '#live-chat') {
    setTimeout(openBuddifyAI, 2500); // 2.5-second load allowance
  }
});
